module.exports = __webpack_public_path__ + "img/comfortaa-v27-latin-700.be307038.svg";